var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fillBgBox",on:{"click":_vm.onClickBannerImg}},[_c('img',{staticClass:"bg",attrs:{"src":_vm.bgImg,"alt":""}}),_c('div',{staticClass:"FBBox_content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }